/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forgotpassword11Inputs */

const en_forgotpassword11 = /** @type {(inputs: Forgotpassword11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forgot Password`)
};

const de_forgotpassword11 = /** @type {(inputs: Forgotpassword11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passwort vergessen?`)
};

/**
* | output |
* | --- |
* | "Forgot Password" |
*
* @param {Forgotpassword11Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const forgotpassword11 = /** @type {((inputs?: Forgotpassword11Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forgotpassword11Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forgotpassword11(inputs)
	return de_forgotpassword11(inputs)
});
export { forgotpassword11 as "forgotPassword1" }